import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { ResultRequestModel } from "../models/resultRequest.model";
import { HttpService } from "./http.service";

const basePath = "/MultiEquipmentGroup";
const request = HttpService.handleRequest();

export const MultiEquipmentGroupService = {
  getAll,
  getList,
  insert,
  update,
  del,
  getById,
  remove,
  insertOrUpdate,
  getAllById
};

async function getAll() {
  return request.get(basePath);
}

async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(basePath, data);
}

async function update(data) {
  return request.put(basePath, data);
}

async function del(data) {
  return request.delete(basePath, { data });
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

async function getAllById(id): Promise<ResultRequestModel>  {
  return request.post(`${basePath}/ListAllEquipmentWithAssociation`, id);
}

export default MultiEquipmentGroupService;